import { useEffect } from 'react'
import { Link, Outlet } from 'react-router-dom'

import type { ReactElement } from 'react'

import enjoyLogoWhite from '@/assets/enjoy-logo-white.webp'

export function AuthLayout(): ReactElement {
  useEffect(() => {
    const root = document.documentElement
    root.classList.add('admin-theme')
    return () => root.classList.remove('admin-theme')
  }, [])

  return (
    <div className="flex min-h-screen flex-col bg-navy bg-[radial-gradient(120%_40%_at_50%_0%,#0B2230_0%,#00131F_55%)] font-body font-light text-[#D9D3C8] antialiased">
      <header className="flex items-center px-5 py-6 sm:px-8">
        <Link to="/" aria-label="Ecossistema Enjoy" className="flex min-h-[44px] items-center">
          <img
            src={enjoyLogoWhite}
            alt="Enjoy"
            className="h-8 w-auto max-w-full"
            width={120}
            height={32}
          />
        </Link>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-gold/[0.22] px-6 py-6 text-center font-display text-[0.78rem] italic text-eco-muted">
        Enjoy &middot; Ecossistema de Negocios &copy; {new Date().getFullYear()}
      </footer>
    </div>
  )
}
